import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./MobileOtpPage.css";
import { useDispatch, useSelector } from "react-redux";
import FormInputStyle2 from "../../../../components/Form/FormInputStyle2";
import FormSelectStyle2 from "../../../../components/Form/FormSelectStyle2";
import FormButtonStyle2 from "../../../../components/Form/FormButtonStyle2";
import moment from "moment";
import { toast } from "react-toastify";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { useNavigate } from "react-router-dom";
import { v6 as uuid } from "uuid";
import {
  login,
  setAllOffers,
  setLead,
  setOffers,
} from "../../../../store/app/appReducer";
import OTPInput from "react-otp-input";
import FormButtonStyleCheckOffer from "../../../../components/Form/FormButtonStyleCheckOffer";
import axios from "axios";
import _ from "lodash";
import {
  setAmountRequired,
  setAppId,
  setEmendateUrl,
  setInternalLead,
  setKfsUrl,
  setKycurl,
  setLeadId,
  setOpportunityId,
  setOpportunityName,
  setResponse,
  setUserData,
} from "../../../../store/app/aaSlice";
import useAddLead from "../../hooks/addLeadtoCRM";
import HeroSection from "../HeroSection/heroSection";

const MobileOtpPage = ({
  isFormStarted,
  setIsFormStarted,
  currentStep,
  setCurrentStep,
  formData,
  setFormData,
}) => {
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [errors, setErrors] = useState({});
  const [isMobileValid, setIsMobileValid] = useState(true);
  const [source, setSource] = useState("");
  const [utmSource, setUtmSource] = useState("");
  const [utmMedium, setUtmMedium] = useState("");
  const [utmTerm, setUtmTerm] = useState("");
  const [affId, setAffId] = useState("");
  const [params] = useSearchParams();
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [isPrefrConsentChecked, setIsPrefrConsentChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeLenders, setActiveLenders] = useState([]);
  const [isTncChecked, setIsTncChecked] = useState(true);
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const [leadId, setLeadId1] = useState("");
  const [searchParams] = useSearchParams();
  const addLead = useAddLead();
  const RESEND_OTP_TIME = 30;

  const [resendCounter, setResendCounter] = useState(RESEND_OTP_TIME);
  const [canResendOtp, setCanResendOtp] = useState(false);


  const lid = searchParams.get("lid");
  const a = Number(params.get("a"));

  const [ipAddress, setIpAddress] = useState("");

  const handleNameChange = (e) => {
    let newName = e.target.value;

    // Remove any character that is not a letter or space
    newName = newName.replace(/[^A-Za-z\s]/g, "");

    // Replace multiple spaces with a single space
    newName = newName.replace(/\s+/g, " ");

    setName(newName);

    // Validate: name must have at least 2 characters after trimming
    setErrors((prev) => ({
      ...prev,
      name: newName.trim().length < 2,
    }));
  };

  async function fetchIp() {
    await fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        // ipAddress = data?.ip;
        setIpAddress(data?.ip);
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }
  useEffect(() => {
    fetchIp();
  }, []);

  useEffect(() => {
    if (!isOtpGenerated) return;

    setResendCounter(RESEND_OTP_TIME);
    setCanResendOtp(false);

    const interval = setInterval(() => {
      setResendCounter(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResendOtp(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOtpGenerated]);


  useEffect(() => {
    if (params.get("source")) setSource(params.get("source"));
    if (params.get("utm_source")) setUtmSource(params.get("utm_source")?.split("?")[0]);
    if (params.get("utm_medium")) setUtmMedium(params.get("utm_medium"));
    if (params.get("utm_term")) setUtmTerm(params.get("utm_term"));
    if (params.get("aff_id")) setAffId(params.get("aff_id"));
    if (params.get("lid")) setLeadId1(params.get("lid"));
  }, [params]);

  useEffect(() => {
    const container = document.getElementById("personal-loan-form");
    if (container)
      container.resetOtpState = () => {
        setIsOtpGenerated(false);
        setOtp("");
      };
  }, []);

  useEffect(() => {
    const fetchActiveLenders = async () => {
      try {
        const res = await callApi(
          `v1/lender/active-lenders`,
          "get",
          {},
          "loan"
        );
        if (res.status === "Success") {
          const apiLenders = res.data.lenderList ?? [];

          const hardcodedLender = {
            _id: "68ad8ed5078abf6c677e4303",
            lender_name: "DMI",
          };

          const mergedLenders = [...apiLenders, hardcodedLender];

          setActiveLenders(mergedLenders);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchActiveLenders();
  }, []);

  let allianceId = "website-pl-ete-lead";

  if (a == 2) {
    allianceId = "zv2";
  } else if (a == 3) {
    allianceId = "cashe";
  } else if (a == 4) {
    allianceId = "bharatpe";
  }

  const fetchOffers = async (leadId, token) => {
    if (!leadId) return false;
    const momentDate = moment("2025-12-09")
      .utcOffset(330)
      .startOf("day")
      .toISOString();

    try {
      // STEP 1: Fetch base offers
      const res = await callApi(
        `v1/loan_offer/list`,
        "post",
        {
          filters: {
            alliance_id: allianceId,
            created_at: {
              $gte: momentDate,
            },
            lead_id: leadId,
          },
        },
        "core",
        token
      );

      if (
        !(
          res.status === "Success" &&
          Array.isArray(res.data?.loan_offerList) &&
          res.data.loan_offerList.length > 0
        )
      ) {
        return { success: false, offers: [] };
      }

      const offers = res.data.loan_offerList;
      // STEP 2: Fetch lender success/fail list
      const lenderListRes = await callApi(
        `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
        "post",
        {},
        "loan",
        token
      );

      let lenderMap = {};

      const failedList = lenderListRes.data?.FailList || [];

      if (
        lenderListRes.status === "Success" &&
        Array.isArray(lenderListRes.data?.Successlist)
      ) {
        lenderMap = Object.fromEntries(
          lenderListRes.data.Successlist.map((lender) => [
            lender.lender_id,
            lender,
          ])
        );
      }

      // STEP 3: Enrich base offers using success lenders
      const enrichedOffers = offers.map((offer) => {
        const lender = lenderMap[offer.lender_id] || {};

        return {
          ...offer,
          apr: lender.apr ?? "",
          kfs_doc: lender.kfs_doc ?? "",
          credit_limit: lender.web_offer ?? "",
          penal_charges: lender.penal_charges ?? "",
          processing_fee: lender.processing_fee ?? "",
          interest_rate: lender.web_interest ?? null,
          lender_name: lender.lender_name ?? offer.lender_name,
        };
      });

      // STEP 4: Sort by priority
      const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);

      // STEP 5: Filter by active lenders if present
      const filteredOffers = activeLenders.length
        ? sortedOffers.filter((offer) =>
          activeLenders.some((lender) => lender._id === offer.lender_id)
        )
        : sortedOffers;

      return {
        success: true,
        offers: filteredOffers,
        failedList: failedList,
      };
    } catch (err) {
      console.error("Error in offer fetching", err);
      toast.error("Something went wrong while fetching offers.");
      return { success: false, offers: [] };
    }
  };

  const generateLead = async (token) => {
    try {
      // -----------------------------
      // 1️⃣ CREATE LEAD (DMI LEAD API)
      // -----------------------------
      const res = await callApi(
        "v1/lead/dmi-lead",
        "post",
        {
          lead: {
            contact_phone: mobile,
            contact_name: name,
            steps_completed: 1,
            alliance_id: allianceId,
            aff_id: params.get("aff_id") || null,
            utm_source: params.get("utm_source")?.split("?")[0] || null,
            source: params.get("source") || null,
            utm_medium: params.get("utm_medium") || null,
            utm_term: params.get("utm_term") || null,
            ads_name: params.get("ads_name") || null,
            ip_address: ipAddress,
            kyc_consent: isTncChecked,
            kyc_consent_datetime: new Date().toISOString(),
            website_kyc_consent: isTncChecked,
            website_kyc_consent_datetime: new Date().toISOString(),
            prefr_kyc_consent: isPrefrConsentChecked,
          },
        },
        "core",
        token
      );

      // -----------------------------
      // 2️⃣ VALIDATE RESPONSE
      // -----------------------------
      if (!res || res.status !== "Success") {
        console.error("DMI Lead API failed:", res);
        toast.error("Unable to create lead at the moment.");
        return false;
      }

      const finalLeadId = res?.data?.lead?._id;

      if (!finalLeadId) {
        console.error("Lead ID missing in response:", res);
        toast.error("Lead creation failed due to invalid response.");
        return false;
      }

      // -----------------------------
      // 3️⃣ STORE INTERNAL LEAD ID
      // -----------------------------
      dispatch(setInternalLead(finalLeadId));

      // -----------------------------
      // 4️⃣ ADD LEAD TO CRM SYSTEM
      // -----------------------------
      try {
        await addLead({
          leadId: finalLeadId,
          lead_type: "live",
          priority: 4,
          stage: "OTP",
        });
      } catch (crmError) {
        console.error("Error adding lead to CRM:", crmError);
        // optionally show toast but not required
      }

      return finalLeadId; // useful if caller needs it
    } catch (error) {
      // -----------------------------
      // 5️⃣ GLOBAL ERROR CATCH
      // -----------------------------
      console.error("Unexpected error in generateLead:", error);
      toast.error("Something went wrong while generating lead.");
      return false;
    }
  };

  // useEffect(() => {
  //   const fetchLeadData = async () => {
  //     try {
  //       if (leadId) return;

  //       const response = await callApi(
  //         "v1/lead/list",
  //         "post",
  //         {
  //           filters: { _id: lid },
  //         },
  //         "core" // specify the core service here
  //       );

  //       const lead = response?.data?.leadList?.[0];
  //       console.log(lead); // assuming API returns array of leads

  //       if (lead) {
  //         setMobile(lead?.contact_phone || "");

  //         // Update the overall formData too
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch lead data:", error);
  //     }
  //   };

  //   fetchLeadData();
  // }, [setFormData]);

  const handleMobileChange = (event) => {
    const value = event.target.value;

    if (/^\d*$/.test(value)) {
      setMobile(value);
      setFormData((prev) => ({
        ...prev,
        mobile: value,
      }));
    }

    setIsMobileValid(value.length === 10);
  };

  const handleConsentChange = () => {
    setIsConsentChecked((prev) => !prev);
  };

  const handlePrefrConsentChange = () => {
    setIsPrefrConsentChecked((prev) => !prev);
  };

  const handleValidation = () => {
    let isValid = true;

    // if (!mobile || mobile.trim() === "") {
    //   isValid = false;
    //   setIsMobileValid(false);
    // }
    if (!/^\d{10}$/.test(mobile) || mobile.length !== 10) {
      isValid = false;
      setIsMobileValid(false);
    } else {
      setIsMobileValid(true);
    }

    // name validation
  if (!name || name.trim().length < 2) {
    setErrors((prev) => ({
      ...prev,
      name: true,
    }));
    toast.error("Please enter your full name");
    isValid = false;
  } else {
    setErrors((prev) => ({
      ...prev,
      name: false,
    }));
  }

    return isValid;
  };

  const handleSendOtp = async () => {
    if (!handleValidation()) {
      return;
    }
    if (!isConsentChecked) {
      toast.error("Please agree to the Terms and Conditions.");
      return;
    }
    if (!isPrefrConsentChecked) {
      toast.error("Please agree to the Prefr Terms & Conditions to continue.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: mobile,
          kyc_consent: isConsentChecked,
          kyc_consent_datetime: new Date().toISOString(),
          website_kyc_consent: isTncChecked,
          website_kyc_consent_datetime: new Date().toISOString(),
          prefr_kyc_consent: isPrefrConsentChecked,
        },
        "messaging"
      );
      if (response.status === "Success") {
        setUserClickData({
          event_name: `otp-send-for-e2e`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_source: utmSource || utmMedium,
          utm_term: utmTerm,
        });
        setFormData((prev) => ({
          ...prev,
          mobile,
          mobiletncchecked: true,
          mobiletnctime: new Date().toISOString(),
          stepDone: 3,
        }));
        toast.success("OTP Sent Successfully");
        setIsOtpGenerated(true);
        setIsFormStarted(true);
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (!canResendOtp) return;

    try {
      setIsLoading(true);

      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: mobile,
          kyc_consent: isConsentChecked,
          kyc_consent_datetime: new Date().toISOString(),
          website_kyc_consent: isTncChecked,
          website_kyc_consent_datetime: new Date().toISOString(),
          prefr_kyc_consent: isPrefrConsentChecked,
        },
        "messaging"
      );

      if (response.status === "Success") {
        setUserClickData({
          event_name: `resend-otp-form-for-e2e`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_source: utmSource || utmMedium,
          utm_term: utmTerm,
        });

        toast.success("OTP Resent Successfully");

        // 🔁 restart timer
        setResendCounter(RESEND_OTP_TIME);
        setCanResendOtp(false);
      } else {
        toast.error("Failed to resend OTP.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while resending OTP.");
    } finally {
      setIsLoading(false);
    }
  };


  const fetchLeadData = async (token) => {
    try {
      if (leadId) return { hasLead: false, hasOffer: false };

      const startDate = moment()
        .subtract(1, "months")
        .startOf("day")
        .toISOString();
      const endDate = moment().endOf("day").toISOString();

      const response = await callApi(
        "v1/lead/list",
        "post",
        {
          filters: {
            contact_phone: mobile,
            created_at: {
              $gte: startDate,
              $lte: endDate,
            },
          },
        },
        "core"
      );

      const sortedLeads = (response?.data?.leadList || []).sort(
        (a, b) =>
          new Date(b.updatedAt || b.createdAt) -
          new Date(a.updatedAt || a.createdAt)
      );

      const lead = sortedLeads[0];
      let hasLead = false;
      let hasOffer = false;
      let currentLeadId = null;

      if (lead) {
        const { _id, steps_completed } = lead;
        console.log(_id, steps_completed);
        hasLead = true;
        currentLeadId = _id;

        if (steps_completed > 3) {
          console.log("lead: ", lead);
          const {
            _id = "",
            steps_completed = 0,
            application_id = "",
            dmi_lead_response_id = "",
            dmi_lead_id = "",
            dmi_offer = "",
            dmi_opportunityid = "",
            amount_required,
            kycurl = "",
            emandateurl = "",
            dmi_opportunityName = "",
            dmi_offers_details,
          } = lead;

          let startStep = 1;

          // 🔑 update redux
          console.log({
            setInternalLead,
            setResponse,
            setAppId,
            setLeadId,
            setOpportunityId,
            setKycurl,
            setAmountRequired,
            setKfsUrl,
            setUserData,
            setEmendateUrl,
            setOpportunityName,
            setOffers,
          });

          dispatch(setInternalLead(_id));
          dispatch(setResponse(dmi_lead_response_id));
          dispatch(setAppId(application_id));
          dispatch(setLeadId(dmi_lead_id));
          // dispatch(setOffers(dmi_offer));
          dispatch(setOpportunityId(dmi_opportunityid));
          dispatch(setKycurl(kycurl));
          dispatch(setAmountRequired(amount_required));
          dispatch(setKfsUrl(lead.kfsurl));
          dispatch(setUserData(lead));
          dispatch(setEmendateUrl(emandateurl));
          dispatch(setOpportunityName(dmi_opportunityName));
          dispatch(setOffers(dmi_offers_details));

          // Check if there are offers
          hasOffer = !!(
            dmi_offers_details &&
            (Array.isArray(dmi_offers_details)
              ? dmi_offers_details.length > 0
              : Object.keys(dmi_offers_details).length > 0)
          );

          // 🔑 decide correct starting step
          if (!steps_completed || steps_completed === 0) {
            setCurrentStep(1);
          }
          if (steps_completed >= 3 && steps_completed <= 16) {
            startStep = steps_completed + 1;
          }

          setCurrentStep(startStep);
        } else {
          dispatch(setLead({ id: _id }));
          dispatch(setInternalLead(_id));
          setFormData((prev) => ({
            ...prev,
            name: lead.contact_name || "",
            mobile: lead.contact_phone || "",
            email: lead.contact_email || "",
            gender: lead.gender || "",
            pancard: lead.pancard || "",
            pincode: lead.pincode || "",
            professionType: lead.profession_type || "",
            dob: moment(lead?.dob).format("YYYY-MM-DD"),
            company_name: lead?.company_name,
            company_type: lead?.company_type,
            work_contact_email: lead?.work_contact_email,
            loan_purpose: lead?.loan_purpose,
            monthly_income: lead?.monthly_income,
            alliance_id: lead?.alliance_id,
          }));
          const offer = await fetchOffers(_id, token);
          if (offer?.success && offer?.offers?.length > 0) {
            hasOffer = true;
            dispatch(
              setAllOffers({
                offers: offer.offers,
                failedList: offer.failedList,
              })
            );
          } else {
            setCurrentStep((prev) => prev + 1);
          }
          // haveOffer ? setCurrentStep(3) : setCurrentStep((prev) => prev + 1);
        }
      } else {
        // No lead found, start from step 2
        generateLead(token);
        setCurrentStep((prev) => prev + 1);
      }
      console.log("Fetched Lead:", lead);
      console.log("going to stpe ", currentStep);
      return { hasLead, hasOffer, leadId: currentLeadId };
    } catch (error) {
      console.error("Failed to fetch lead data:", error);
      return { hasLead: false, hasOffer: false, leadId: null };
    }
  };

  const handleOtpSubmit = async () => {
    if (otp.length !== 4) {
      toast.error("Please enter a valid 4-digit OTP.");
      return;
    }

    try {
      setIsLoading(true);
      const otpResponse = await callApi(
        "v1/sms/validate-otp",
        "post",
        {
          contact_phone: mobile,
          otp,
        },
        "messaging"
      );

      if (otpResponse.status === "Success") {
        setUserClickData({
          event_name: `otp-submit-for-e2e`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_source: utmSource || utmMedium || "",
          utm_term: utmTerm,
        });
        toast.success("OTP Verified Successfully");
        const leadData = await fetchLeadData(otpResponse?.data.token);
        console.log("leadData: ", leadData);

        dispatch(
          login({
            ...otpResponse.data.customer,
            token: otpResponse.data.token,
          })
        );
        localStorage.setItem("mobile", mobile);

        // Call useAddLead hook twice if there is lead and offer
        if (leadData?.hasOffer && leadData?.leadId) {
          try {
            // Second call for offer
            await addLead({
              leadId: leadData.leadId,
              lead_type: "live",
              priority: 2,
              stage: "Have offer",
            });
            //commented on 19th march for live flow to skip direct offer page logic
            //setCurrentStep(6);
            setCurrentStep(2);
          } catch (error) {
            console.error("Error adding offer to CRM:", error);
          }
        }
        const leadResponse = await callApi(
          "v1/lead/lead-from-phone",
          "post",
          {
            phone: mobile,
            otp_page: "personal-loan-ete",
            website_kyc_consent: isTncChecked,
            website_kyc_consent_datetime: new Date().toISOString(),
            prefr_kyc_consent: isPrefrConsentChecked,
          },
          "core",
          otpResponse.data.token
        );
        // const leadResponse = await callApi(
        //   "v1/lead/lead-from-phone",
        //   "post",
        //   {
        //     phone: mobile,
        //     website_kyc_consent: isTncChecked,
        //     website_kyc_consent_datetime: new Date().toISOString(),
        //     utm_source: utmSource || utmMedium,
        //     otp_page: "offer-check-v1",
        //     ip_address: ipAddress,
        //   },
        //   "core",
        //   otpResponse.data.token
        // );

        // const leadId = leadResponse?.data?.lead?._id;
        // if (leadId) {
        //   try {
        //     await fetch(
        //       "https://campaigns.digitmoney.in/api/offercheck/requestjson.php?case=insert_digit_money_data",
        //       {
        //         method: "POST",
        //         headers: {
        //           "Content-Type": "application/json",
        //         },
        //         body: JSON.stringify({
        //           api_key: "fca6416db1074658d6b6823380d18f04",
        //           mobile: mobile,
        //           lead_id: leadId,
        //         }),
        //       }
        //     );
        //   } catch (e) {
        //     console.error("Error in external lead insert:", e);
        //   }
        // }
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    } catch (otpError) {
      console.error("Error occurred while verifying OTP:", otpError);
      //toast.error("An error occurred while verifying OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return !isOtpGenerated ? (

    <>
      <HeroSection />
      <div className="lead-capture-container1 ">
        {!isOtpGenerated ? (
          <>
            <div className="relative flex items-center my-6 px-2">
              <div className="flex-grow border-t border-gray-300"></div>

              <span className="mx-2 text-sm font-medium text-gray-500 whitespace-nowrap">
                Check your loan eligibility instantly
              </span>

              <div className="flex-grow border-t border-gray-300"></div>
            </div>

            <input type="hidden" name="utm_campaign" value="" />
            <input type="hidden" name="utm_source" value={utmSource || ""} />
            <input type="hidden" name="utm_medium" value="" />
            <input type="hidden" name="utm_content" value="" />
            <input type="hidden" name="click_id" value="" />
            <input type="hidden" name="aff_id" value={affId || ""} />
            <input type="hidden" name="src" value={source || ""} />

            <FormInputStyle2
              label="Full Name as per Pan Card"
              value={name}
              maxlength={100}
              onChange={handleNameChange}
              isValid={!errors.name}
              errorMessage="Please enter a valid name with only one space between words"
            />

            <FormInputStyle2
              type="text"
              name="mobile"
              isValid={isMobileValid}
              id="mobile"
              minLength="10"
              maxLength="10"
              pattern="[0-9]{10}"
              value={mobile}
              onChange={handleMobileChange}
              required
              label={"Mobile Number"}
              inputMode="numeric"
              errorMessage={"Please enter a valid Mobile Number"}
            />
            
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                id="consent"
                checked={isConsentChecked}
                onChange={handleConsentChange}
              />
              <label htmlFor="consent" className="consent">
                I have read and agreed to the{" "}
                <a className="anc-font-pf" href="https://digitmoney.in/terms">
                  Terms of Use
                </a>{" "}
                and hereby appoint DigitMoney and its{" "}
                <a className="anc-font-pf" href="https://digitmoney.in/lenders">
                  Lending Partners
                </a>{" "}
                to receive my credit information from credit bureaus. By
                submitting my details I override my NDNC registration & authorize
                DigitMoney and its{" "}
                <a className="anc-font-pf" href="https://digitmoney.in/lenders">
                  Lending Partners
                </a>{" "}
                / representatives to contact me through Call, SMS, Email, Whatsapp
                or any other mode. You also authorize us to send you promotional
                offers of financial & non-financial products or services from time
                to time.
              </label>
            </div>

            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                id="prefr-consent"
                checked={isPrefrConsentChecked}
                onChange={handlePrefrConsentChange}
              />
              <label htmlFor="prefr-consent" className="consent">
              I agree to the{" "}
              <a className="anc-font-pf" href="https://prefr.com/terms_and_conditions">
                T&Cs
              </a>{" "}
              of{" "}
              <a className="anc-font-pf" href="https://prefr.com/bureau_terms_tu">
                TUCIBIL
              </a>{" "}
              and{" "}
              <a className="anc-font-pf" href="https://prefr.com/bureau_terms_crif">
                CRIF Highmark
              </a>{" "}
              ("CIC") and explicitly consent to Prefr fetching my Credit Information
              from all or any of the above CICs and sharing the same with me and using
              it for the purpose agreed under the above T&Cs.
            </label>
            </div>

            <FormButtonStyleCheckOffer
              style={{ backgroundColor: "#12F280" }}
              text="Get OTP"
              onClick={handleSendOtp}
              disabled={!isMobileValid || isLoading}
              id="btn-get-otp-landing-v9"
              className="tracking-btn-get-otp-landing-v4"
            />
          </>
        ) : (
          <div className="otp-verification-container">
            <h3>Mobile OTP verification</h3>
            <p>
              A One Time Password (OTP) has been sent to your mobile number{" "}
              <strong>{mobile}</strong>{" "}
              <span
                onClick={() => {
                  setIsOtpGenerated(false);
                  setOtp("");
                  setCurrentStep(1);
                }}
              >
                Edit
              </span>{" "}
              Please enter the OTP below
            </p>

            <div className="otp-input-field">
              <OTPInput
                value={otp}
                onChange={(val) => setOtp(val)}
                numInputs={4}
                isInputNum={true}
                shouldAutoFocus={true}
                inputStyle={{
                  width: "71px",
                  height: "50px",
                  borderRadius: "5px",
                  border: "1px solid #B3B3B3",
                  fontSize: "24px",
                  textAlign: "center",
                }}
                containerStyle={{
                  display: "flex",
                  gap: "19px",
                  margin: "16px 0",
                  justifyContent: "center",
                }}
                placeholder={"----"}
                renderInput={(props) => <input {...props} />}
              />
            </div>

            <FormButtonStyleCheckOffer
              // style={{ backgroundColor: "#12F280" }}
              text="Verify OTP"
              onClick={handleOtpSubmit}
              disabled={otp.length !== 4 || isLoading}
              isLoading={isLoading}
              id="btn-verify-otp-landing-v9"
              className="tracking-btn-verify-otp-landing-v4"
            />

            <p className="resend-otp1">
              Don’t receive the OTP? Click here to{" "}
              <span onClick={handleResendOtp}>Regenerate OTP</span>
            </p>
          </div>
        )}
      </div>
    </>
  ) : (
    <>
      {/* Full screen wrapper */}
      <div className="min-h-[70dvh] flex flex-col items-center justify-between   bg-white">

        {/* Top illustration & heading */}
        <div className="w-full max-w-[390px] text-center space-y-2 my-auto">
          <img
            src="/assets/img/Layer_1 (47).png"
            className="h-[99px] w-[71px] mx-auto"
            alt="Lock"
          />

          <h1 className="text-[20px] font-bold text-gray-900">
            Verify number security
          </h1>

          <p className="text-gray-500 text-sm flex items-center justify-center gap-2">
            Your details are safe with us
            <img
              src="/assets/img/Layer_1 (48).png"
              className="h-[11px] w-[8px]"
              alt="Secure"
            />
          </p>
        </div>

        {/* OTP content */}
        <div className="w-full max-w-[390px] text-center space-y-3">

          <h3 className="text-[18px] font-medium text-gray-900">
            We can help prefill your information
          </h3>

          <p className="text-[13px] text-gray-500">
            Enter OTP sent to{" "}
            <span className="font-bold text-gray-800">
              +91-{mobile || 9999999999}
            </span>{" "}
            <button
              onClick={() => {
                setIsOtpGenerated(false);
                setOtp("");
                setCurrentStep(1);
              }}
              className="ml-1 text-black font-bold hover:underline"
            >
              Edit
            </button>
          </p>

          {/* OTP Input */}
          <div className="flex justify-center py-2">
            <OTPInput
              value={otp}
              onChange={(val) => setOtp(val)}
              numInputs={4}
              isInputNum={true}
              shouldAutoFocus={true}
              inputStyle={{
                width: "71px",
                height: "50px",
                borderRadius: "5px",
                border: "1px solid #B3B3B3",
                fontSize: "24px",
                textAlign: "center",
              }}
              containerStyle={{
                display: "flex",
                gap: "19px",
                margin: "16px 0",
                justifyContent: "center",
              }}
              placeholder={"----"}
              renderInput={(props) => <input {...props} />}
            />

          </div>

          {/* Resend OTP */}
          <p className="text-sm text-gray-500">
            {canResendOtp ? (
              <>
                Don’t receive the OTP?{" "}
                <span
                  onClick={handleResendOtp}
                  className="text-blue-600 font-medium cursor-pointer hover:underline"
                >
                  Resend OTP
                </span>
              </>
            ) : (
              <>
                Resend OTP in{" "}
                <span className="font-medium text-gray-700">
                  {resendCounter}s
                </span>
              </>
            )}
          </p>

          {/* Verify Button */}
          <div className="pt-3">
            <FormButtonStyleCheckOffer
              text="Verify OTP"
              onClick={handleOtpSubmit}
              disabled={otp.length !== 4 || isLoading}
              isLoading={isLoading}
              id="btn-verify-otp-personal-details-v9"
              className="tracking-btn-verify-otp-personal-details-v5 w-full"
            />
          </div>

        </div>
      </div>
    </>

  );
};

export default MobileOtpPage;
